import styled from "styled-components/macro";

export const Card = styled.li`
  width: 424px;
  border-radius: 16px;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
`;

export const Image = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Created = styled.p`
  font-size: 18px;
  line-height: 25px;
  color: #A7A7A7;
  margin-bottom: 8px;

  @media (max-width: 979px) {
    font-size: 15px;
  }
`;

export const Title = styled.h3`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  min-height: 90px;
  font-weight: 600;
  line-height: 86%;
  margin-bottom: 22px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 979px) {
    font-size: 30px;
    min-height: 78px;
  }

`;

export const Tags = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 40px;
`;

export const Tag = styled.span`
  background-color: #BFDCF5;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 22px;
  white-space: nowrap;
  margin-right: 6px;
    
    &:last-child {
      margin-right: 0;
    }

  @media (max-width: 979px) {
    font-size: 14px;
  }
`;
